import React from 'react';

import type { ModeReglementType, RegieModeReglementType } from '@/types';

export type ModeReglementContextType = {
  /** Tous les modes de règlements généraux (toutes régies confondues) */
  modesReglements: ModeReglementType[];
  /** Modes de règlement actifs généraux (toutes régies confondues) */
  modesReglementsActifs: ModeReglementType[];
  /** Modes de règlements de la régie sélectionnée */
  regieModesReglement: RegieModeReglementType[];
  getModesReglements: () => void;
  getRegieModesReglement: () => Promise<void>;
};

const ModeReglementContext = React.createContext<ModeReglementContextType>({
  modesReglements: [],
  modesReglementsActifs: [],
  regieModesReglement: [],
  getModesReglements: null,
  getRegieModesReglement: null,
});

export default ModeReglementContext;
